import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex pt-8"
}
const _hoisted_2 = { class: "flex flex-col w-full" }
const _hoisted_3 = { class: "flex flex-col border-b-2 border-gray-200 pb-5" }
const _hoisted_4 = { class: "font-semibold text-3xl text-gray-900" }
const _hoisted_5 = { class: "text-gray-600 font-normal text-base" }
const _hoisted_6 = { class: "flex mt-8 p-8 bg-blue-600 rounded-lg justify-between" }
const _hoisted_7 = { class: "text-white" }
const _hoisted_8 = { class: "font-semibold text-lg" }
const _hoisted_9 = { class: "font-light text-sm mt-1" }


export default /*#__PURE__*/_defineComponent({
  __name: 'SchoolStructureIntro',
  props: {
    step: {
        type: Number,
        required: true,
    },
},
  emits: ['update:step', 'next-step'],
  setup(__props, { emit }) {

const props = __props;






const goToNextStep = () => {
    emit('update:step', props.step + 1)
}

return (_ctx: any,_cache: any) => {
  return (__props.step == 0)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.$t("add_grades_class_component.step_0.title")), 1),
            _createElementVNode("h4", _hoisted_5, _toDisplayString(_ctx.$t("add_grades_class_component.step_0.subtitle")), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("h4", _hoisted_8, _toDisplayString(_ctx.$t("add_grades_class_component.step_0.school_structure")), 1),
              _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$t("add_grades_class_component.step_0.tell_us")), 1)
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                onClick: goToNextStep,
                class: "bg-white border border-gray-300 font-semibold text-sm shadow-[0px 1px 2px 0px rgba(16, 24, 40, 0.05)] py-[9px] px-[13px] rounded-lg"
              }, _toDisplayString(_ctx.$t("add_grades_class_component.step_0.btn_start")), 1)
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})